import { MessageBubble } from './MessageBubble'
import { TypingIndicator } from './TypingIndicator'
import { useChat } from './hooks'
import { useEffect } from 'react'

// Message list component
export function MessageList() {
  const { messages, isLoading } = useChat()
  useEffect(() => {
    console.log('isLoading', isLoading)
  }, [isLoading])
  if (messages.length === 0) {
    return null
  }

  return (
    <div className="flex-1 p-4">
      {messages.map((message) => (
        <MessageBubble key={message.id} message={message} />
      ))}
      {isLoading && <TypingIndicator />}
    </div>
  )
}
